<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">settings</v-icon>
            Edit Project
          </span>
        </v-card-title>
        <v-card-text>
            <v-form ref="edit_project" data-vv-scope="edit_project" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.name"
                    label="Project name*"
                    v-validate="'required|min:2'"
                    data-vv-name="edit_project.name"
                    :error-messages="errors.collect('edit_project.name')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.domain"
                    label="Domain*"
                    v-validate="'required'"
                    data-vv-name="edit_project.domain"
                    :error-messages="errors.collect('edit_project.domain')"
                    hint="www.example.com or example.com"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="form.verify_domain"
                    color="primary"
                    label="Verify domain"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.subdomains"
                    label="Subdomains"
                    hint="www.sub1.example.com, sub2.example.com"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveProject()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'EditProjectModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['editProjectDialog', 'projectData', 'loading'],
  data () {
    return {
      dialog: this.editProjectDialog,
      form: {
        name: this.projectData.name,
        domain: this.projectData.domain,
        verify_domain: this.projectData.verify_domain,
        subdomains: this.projectData.subdomains ? this.projectData.subdomains.join(', ') : ''
      },
      project: {
        name: '',
        domain: '',
        verify_domain: true,
        subdomains: []
      },
      dictionary: {
        en: {
          custom: {
            'edit_project.name': {
              required: 'Project name required',
              min: 'Required at least 2 symbols'
            },
            'edit_project.domain': {
              required: 'Domain name required',
              min: 'Required at least 2 symbols'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    editProjectDialog: {
      handler () {
        this.dialog = this.editProjectDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('editProjectDialog', this.dialog)
      }
    },
    projectData: {
      handler () {
        this.form.name = this.projectData.name
        this.form.domain = this.projectData.domain
        this.form.verify_domain = this.projectData.verify_domain
        this.form.subdomains = this.projectData.subdomains ? this.projectData.subdomains.join(', ') : ''
      }
    }
  },
  computed: {
    selectEngine: function () {
      return this.$store.state.metadata.selectEngines
    }
  },
  methods: {
    saveProject () {
      this.$validator.validateAll('edit_project').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)
          this.formToProject()

          this.$store.dispatch('EDIT_PROJECT', this.project).then(res => {
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateProject')
            this.$toasted.show('Project was successfully edited')
            this.closeModal()
          }, err => {
            console.log('login error', err)
            this.$parent.$emit('loading', false)
            this.$toasted.show('EDIT_PROJECT ERROR: ' + this.$services.getApiError(err), { type: 'error' })
          })
        }
      })
    },
    closeModal () {
      this.dialog = false
      setTimeout(() => {
        this.$validator.errors.clear('edit_project')
      }, 500)
    },
    formToProject () {
      this.project.id = this.projectData.id
      this.project.name = this.form.name
      this.project.domain = this.form.domain
      this.project.subdomains = this.form.subdomains.split(',').map((subdomain) => { return subdomain.trim() }).filter(subdomain => subdomain)
    },
    clearForm () {
      this.form = {
        name: '',
        domain: '',
        verify_domain: true,
        subdomains: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/edit-project-modal/EditProjectModal.vue